"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var calculateProficiencyScore_1 = __importDefault(require("../calculateProficiencyScore"));
var constants_1 = require("../../constants");
/**
 * Calculates a new rating based on past ratings
 * and latest rating.
 *
 * @param {string} rating The latest rating.
 * @param {array} ratings The previous ratings.
 */
function calculateNewProficiencyScore(rating, pastRatings) {
    // Get the current rating using a recent attempts
    // count that is 1 smaller than the number used
    // to calculate the current score (because we are
    // adding a new attempt to it).
    var currentScore = calculateProficiencyScore_1.default(pastRatings, constants_1.RECENT_ATTEMPTS_COUNT - 1);
    // Add the new score the the total of recent ones
    var newScore = currentScore + constants_1.RATING_VALUES[rating];
    return newScore;
}
exports.default = calculateNewProficiencyScore;
//# sourceMappingURL=calculateNewProficiencyScore.js.map